import gql from 'graphql-tag';

// data: {userIds:[global_user_id, ...]}
export const SEND_SIGNUP_EMAIL = gql`
mutation sendSignupEmailsToUser ($data: SendSignupEmailInput!){
  sendSignupEmail(data: $data) {
    sentEmail {
      id
      messageId
      recipient
      emailType
    }
    ok
    errorMessage
  }
}
`;
